// @ts-check
import React, { Fragment } from "react"
import { Link } from "react-router"
import styled from "react-emotion"
import { direction as directionContext } from "features/editor/ContextProviders"
import Droppable from "features/editor/dnd/Droppable"
import { boolean } from "../../attributes/items/primitives"
import { Icon } from "ui"
import { BlockName } from "features/editor/Block"
import { evaluateFormulas } from "../../formulas/evaluate"

/**
 * @param {BlockTypeProps} props
 */
export default function ContainerBlock(props) {
    var direction = props.config.attributes.direction || props.context.direction

    // OK this is very strange and definitely not the way to do things...
    var initialProps = props.utils.getRootProps()

    var isColumn = direction === "column"
    // if (JSON.stringify(props).indexOf("flexDirection") !== -1) debugger
    if (initialProps.innerstyle.flexDirection) {
        isColumn = initialProps.innerstyle.flexDirection === "column"
        direction = isColumn ? "column" : "row"
    }

    var rootProps = props.utils.getRootProps({
        className: [
            "device-" + props.context.deviceType,
            "container",
            { "container-column": isColumn },
        ],
        direction: direction,
    })

    rootProps.style = { ...rootProps.style, ...rootProps.innerstyle }

    const evaluateFormulasWithContext = evaluateFormulas(props.context)
    const link = evaluateFormulasWithContext(props.config.attributes.link)
    const linkWrapper = children =>
        link.indexOf("://") == -1 ? (
            <Link to={link}>{children}</Link>
        ) : (
            <a href={link}>{children}</a>
        )
    const wrapLink = link && !props.context.editor.isEditing ? linkWrapper : comp => comp

    return (
        <directionContext.Provider value={direction}>
            {wrapLink(
                <div {...rootProps} id={props.id}>
                    {rootProps.selected && (
                        <DirectionIndicator>
                            {isColumn ? (
                                <Icon margin="none" icon="long-arrow-alt-down" />
                            ) : (
                                <Icon margin="none" icon="long-arrow-alt-right" />
                            )}
                        </DirectionIndicator>
                    )}

                    {!props.childBlocks ? (
                        <div className=" drop-here">{props.renderDroppable(null)}</div>
                    ) : rootProps.childIsSelected ? (
                        ""
                    ) : (
                        props.renderDroppable(null, props.childBlocks.length)
                    )}
                    {/* props.renderDroppable(null, props.childBlocks.length)} */}

                    {props.childBlocks.map((child, position) => (
                        <Fragment key={child.id}>
                            <Droppable
                                payload={{ id: props.id, position }}
                                onDrop={(...args) =>
                                    console.log("dropped element with args", ...args)
                                }
                            >
                                {({ getRootProps, isDraggingOver }) => (
                                    <div
                                        className={`invisible-droppable ${
                                            isDraggingOver ? "isDraggingOver" : ""
                                        }`}
                                    >
                                        <div
                                            {...getRootProps({
                                                className: "droppable droppable-" + direction,
                                            })}
                                        />
                                    </div>
                                )}
                            </Droppable>
                            {props.utils.renderChild(child, position)}
                        </Fragment>
                    ))}
                    <BlockName className="block-name">
                        {props.config.attributes.label || props.id}
                    </BlockName>
                    <Droppable
                        payload={{ id: props.id, position: props.childBlocks.length }}
                        onDrop={console.log}
                    >
                        {({ getRootProps, isDraggingOver }) => (
                            <div
                                className={`invisible-droppable ${
                                    isDraggingOver ? "isDraggingOver" : ""
                                }`}
                            >
                                <div
                                    {...getRootProps({
                                        className: "droppable droppable-" + direction,
                                    })}
                                />
                            </div>
                        )}
                    </Droppable>
                </div>
            )}
        </directionContext.Provider>
    )
}
ContainerBlock.isDroppable = true

ContainerBlock.attributes = [
    //boolean({ field: "direction", label: "Column?", onCheckedValue: "column" }),
]

const DirectionIndicator = styled("div")`
    color: orange;
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 15px;
    padding: 0px;
    line-height: 0px;
`



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/layout/Container.js